require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-2024-07-29-savoir-media-telefiction-serie-documentaire-la-vie-continue.json") })
        }
      }, "path---news-2024-07-29-savoir-media-telefiction-serie-documentaire-la-vie-continue");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-2024-07-29-savoir-media-telefiction-serie-documentaire-la-vie-continue!./.cache/json/news-2024-07-29-savoir-media-telefiction-serie-documentaire-la-vie-continue.json
// module id = 477
// module chunks = 231608221292675